<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">
    {{ (event.ID ? 'bikeshop.users.edit_technician_leave' : 'bikeshop.users.add_technician_leave') | translate }}</h4>
  <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
    <span class="hubtiger-close"></span>
  </button>
</div>
<div class="modal-body">

  <div class="row margin-top-8">
    <div class="col-md-4 label">
      {{ 'bikeshop.users.select_a_technician' | translate}}:
    </div>
    <div class="col-md-8">
      <p-dropdown [options]="technicianOptions" [(ngModel)]="technician" [disabled]="event.ID"
                  placeholder="{{ 'bikeshop.users.select_a_technician' | translate}}"></p-dropdown>
    </div>
  </div>

  <div>
    <div class="row margin-top-8">
      <div class="col-md-4 label">{{ 'bikeshop.users.event_description' | translate }}:</div>
      <div class="col-md-8">
        <input type="text" pInputText [(ngModel)]="event.Description"/>
      </div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-4 label">Event Date:</div>
      <div class="col-md-8">
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            <i class="fa fa-calendar-check-o"></i>
          </span>
          <p-calendar dateFormat="{{countryData.DatePickerFormat}}" placeholder="" [minDate]="minDate"
                      [(ngModel)]="event.StartTime">
          </p-calendar>
        </div>
      </div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-4 label">{{ 'general.start' | translate }}:</div>
      <div class="col-md-8">
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            <i class="fa fa-clock-o"></i>
          </span>
          <p-calendar dateFormat="HH:mm" [timeOnly]="true" [(ngModel)]="startTime"
                      (ngModelChange)="endTime=startTime">
          </p-calendar>
        </div>
      </div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-4 label">{{ 'general.end' | translate }}:</div>
      <div class="col-md-8">
        <div class="p-inputgroup">
          <span class="p-inputgroup-addon">
            <i class="fa fa-clock-o"></i>
          </span>
          <p-calendar dateFormat="HH:mm" [timeOnly]="true" [(ngModel)]="endTime"></p-calendar>
        </div>
      </div>
    </div>
    <div class="row margin-top-8" *ngIf="!event.ID">
      <div class="col-md-4 label">{{ 'bikeshop.modal.add_edit_user.technician_form.event.recurring' | translate }}
        :
      </div>
      <div class="col-md-8">
        <p-inputSwitch [(ngModel)]="event.IsRecurringEvent"></p-inputSwitch>
      </div>
    </div>
    <!--<div class="row margin-top-8" *ngIf="event.IsRecurringEvent">
      <div class="col-md-4 label">{{'bikeshop.modal.add_edit_user.technician_form.event.occurs_every_day' | translate}}:
      </div>
      <div class="col-md-8">
        <input type="number" pInputText [(ngModel)]="event.RecurIntervalDays" />
      </div>
    </div>
    <div class="row margin-top-8" *ngIf="event.IsRecurringEvent">
      <div class="col-md-4 label">{{'bikeshop.modal.add_edit_user.technician_form.event.repeats_times' | translate}}:
      </div>
      <div class="col-md-8">
        <input type="number" pInputText [(ngModel)]="event.RecurringCount" />
      </div>
    </div>-->
    <div class="margin-top-16" *ngIf="event.IsRecurringEvent">
      <h6>{{ 'bikeshop.users.repeating_info' | translate }}</h6>
      <div class="row margin-top-8">
        <div class="col-md-4 label">*{{ 'bikeshop.users.repeat_every' | translate }}:</div>
        <div class="col-md-8" style="display: grid;">
          <div class="day-picker-container">
            <!--           todo (dcorbett) no [binary] on inputswitch -->
            <p-inputSwitch [(ngModel)]="weekDays.Monday" [ngModelOptions]="{standalone: true}">
            </p-inputSwitch>
            <span>{{ 'general.monday' | translate }}</span>
          </div>
          <div class="day-picker-container">
            <p-inputSwitch [(ngModel)]="weekDays.Tuesday" [ngModelOptions]="{standalone: true}">
            </p-inputSwitch>
            <span>{{ 'general.tuesday' | translate }}</span>
          </div>
          <div class="day-picker-container">
            <p-inputSwitch [(ngModel)]="weekDays.Wednesday" [ngModelOptions]="{standalone: true}">
            </p-inputSwitch>
            <span>{{ 'general.wednesday' | translate }}</span>
          </div>
          <div class="day-picker-container">
            <p-inputSwitch [(ngModel)]="weekDays.Thursday" [ngModelOptions]="{standalone: true}">
            </p-inputSwitch>
            <span>{{ 'general.thursday' | translate }}</span>
          </div>
          <div class="day-picker-container">
            <p-inputSwitch [(ngModel)]="weekDays.Friday" [ngModelOptions]="{standalone: true}">
            </p-inputSwitch>
            <span>{{ 'general.friday' | translate }}</span>
          </div>
          <div class="day-picker-container">
            <p-inputSwitch [(ngModel)]="weekDays.Saturday" [ngModelOptions]="{standalone: true}">
            </p-inputSwitch>
            <span>{{ 'general.saturday' | translate }}</span>
          </div>
          <div class="day-picker-container">
            <p-inputSwitch [(ngModel)]="weekDays.Sunday" [ngModelOptions]="{standalone: true}">
            </p-inputSwitch>
            <span>{{ 'general.sunday' | translate }}</span>
          </div>
        </div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-4 label">*{{ 'bikeshop.users.repeat_until' | translate }}:</div>
        <div class="col-md-8">
          <div class="p-inputgroup">
            <span class="p-inputgroup-addon">
              <i class="fa fa-calendar-check-o"></i>
            </span>
            <p-calendar dateFormat="{{countryData.DatePickerFormat}}" [minDate]="event.StartTime"
                        [(ngModel)]="event.endDate"></p-calendar>
          </div>
        </div>
      </div>
    </div>
    <div class="row margin-top-8">
      <div class="col-md-6">
        <button pButton type="button" class="p-button-raised alternate full-width" *ngIf="event.ID"
                label="{{'bikeshop.modal.add_edit_user.technician_form.event.button.delete_event' | translate}}"
                (click)="deleteEvent()" [disabled]="busy"></button>
      </div>
      <div class="col-md-6">
        <button pButton type="button" class="p-button-raised full-width"
                label="{{'bikeshop.modal.add_edit_user.technician_form.event.button.save_event' | translate}}"
                (click)="saveEvent()" [disabled]="busy || !valid()"></button>
      </div>
    </div>
  </div>
</div>
<p-confirmDialog key="remove_recurring_events"></p-confirmDialog>
<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
